module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#ffffff"
    }
  }) : _c('line-chart', {
    attrs: {
      "chart-data": _vm.datacollection,
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0098e910!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasksChart.vue
// module id = 1429
// module chunks = 1